import React, { useContext, useMemo } from 'react';
import { ConfigProvider } from 'antd';
import { ThemeContext } from '@/state/contexts';
import { darkThemeConfig, lightThemeConfig } from '@/theme';

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { darkTheme } = useContext(ThemeContext);

  const antTheme = useMemo(
    () => (darkTheme ? darkThemeConfig : lightThemeConfig),
    [darkTheme]
  );

  return <ConfigProvider theme={antTheme}>{children}</ConfigProvider>;
};
